import React, { useEffect, useState } from "react";
// import { OPTION_KEYS } from "./Quiz"; // reuse the same constant
import "../css/Quiz.css";
import { OPTION_KEYS } from "../../../utilis/quizconstant";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import QuizService from "../../../services/QuizService";

/* ── Score Ring ── */
export function ScoreRing({ percentage, pass }) {
  const r = 38;
  const circ = 2 * Math.PI * r;
  const dash = (Math.min(percentage, 100) / 100) * circ;
  return (
    <div className="score-ring">
      <svg width="90" height="90" viewBox="0 0 90 90">
        <circle
          cx="45"
          cy="45"
          r={r}
          fill="none"
          stroke="#dee2e6"
          strokeWidth="7"
        />
        <circle
          cx="45"
          cy="45"
          r={r}
          fill="none"
          stroke={pass ? "rgb(123,31,162)" : "#dc3545"}
          strokeWidth="7"
          strokeDasharray={`${dash} ${circ}`}
          strokeLinecap="round"
        />
      </svg>
      <div className="score-ring-label">
        {percentage}%<small>score</small>
      </div>
    </div>
  );
}

/* ── Result Icon ── */
export function ResultIcon({ type }) {
  if (type === "correct")
    return <div className="result-icon bg-success text-white">✓</div>;
  if (type === "wrong")
    return <div className="result-icon bg-danger text-white">✕</div>;
  return <div className="result-dot" />;
}

/* ── Question Result Card ── */
export function QuestionCard({ result, index, allOptions }) {

  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body p-4">
        {/* Meta */}
        <div className="d-flex align-items-center gap-2 mb-2">
          <span
            className="text-uppercase fw-semibold"
            style={{
              fontSize: "10px",
              color: "rgb(123, 31, 162)",
              letterSpacing: "0.1em",
            }}
          >
            Question {index + 1}
          </span>
          <span
            className={`badge rounded-pill ${result.isCorrect ? "text-bg-success" : "text-bg-danger"}`}
            style={{ fontSize: "11px" }}
          >
            {result.isCorrect ? "✓ Correct" : "✕ Incorrect"}
          </span>
        </div>

        {/* Question */}
        <p
          className="fw-semibold mb-3"
          style={{ color: "rgb(123, 31, 162)", fontSize: "0.95rem" }}
        >
          {result.question}
        </p>

        {/* Options */}
        <div className="d-flex flex-column gap-2">
          {allOptions.map((opt) => {
            const isCorrect = opt === result.correctAnswer && result.isCorrect;
            const isWrong = opt === result.selectedAnswer && !result.isCorrect;
            let cls = "result-option";
            let icon = "dot";
            if (isCorrect) {
              cls += " opt-correct";
              icon = "correct";
            } else if (isWrong) {
              cls += " opt-wrong";
              icon = "wrong";
            }
            return (
              <div key={opt} className={cls}>
                <ResultIcon type={icon} />
                {opt}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* ── Main Results Page ── */
export function QuizResultsPage({
  responseData,
  detail,
  onRestart,
  isLastQuiz,
  allQuizes,
  sakyo,
  toggleModal,
  isModalOpen,
  courseName,
  firstMail,
  isCertLoading,
  id
}) {
  const pass = responseData.scorePercentage >= 60;
  const user = JSON.parse(localStorage.getItem("user"));
  const [date, setDate] = useState(null)
  const userName = user?.fullName;
  // ── All-quizzes completion & score check ──────────────────────────────────
  // Only evaluated when this is the last quiz.
  let allCompleted = false;
  let allAbove50 = false;

  const resetScore = () => {
    (allQuizes ?? []).forEach((q) => {
      localStorage.removeItem(`quiz_progress_${q.slug}`);
      localStorage.removeItem(`quiz_score_${q.slug}`);
    });

    const response = QuizService.resetAll(id)
    console.log("🚀 ~ resetScore ~ response:", response)
  }

  if (sakyo && allQuizes?.length) {
    const scores = allQuizes.map((q) => {
      const raw = localStorage.getItem(`quiz_score_${q.slug}`);
      return raw !== null ? Number(raw) : null;
    });
    allCompleted = scores.every((s) => s !== null);
    allAbove50 = allCompleted && scores.every((s) => s >= 60);

  }

  useEffect(() => {
    if (sakyo && allCompleted && allAbove50) {
      setDate(new Date().toLocaleDateString());
    }
  }, [sakyo, allCompleted, allAbove50]);

  // Map questionId to its options
  const optionsMap = {};
  detail?.quizDetail?.forEach((q) => {
    optionsMap[q.id] = OPTION_KEYS.map((k) => q[k]).filter(Boolean);
  });

  return (
    <div className="results-bg">
      <div className="container" style={{ maxWidth: 760 }}>
        {/* Header */}
        <p
          className="text-uppercase fw-semibold mb-1"
          style={{ fontSize: "11px", color: "black", letterSpacing: "0.15em" }}
        >
          Quiz Complete
        </p>
        {/* <h2 className="fw-bold mb-4" style={{ color: '#212529' }}>
          {responseData.quizName}
        </h2> */}

        {/* Score Summary */}
        <div className="card border-0 shadow-sm mb-5">
          <div className="card-body p-4 d-flex align-items-center gap-4">
            <ScoreRing percentage={responseData.scorePercentage} pass={pass} />
            <div>
              <div
                className="fw-bold mb-1"
                style={{ fontSize: "1.6rem", color: "#212529" }}
              >
                {responseData.correctAnswers} / {responseData.totalQuestions}
              </div>
              <p className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>
                questions answered correctly
              </p>
              <span
                className={`badge rounded-pill fs-6 px-3 py-2 ${pass ? "text-bg-success" : "text-bg-danger"}`}
              >
                {pass ? "🎉 Passed" : "Needs Improvement"}
              </span>
            </div>
          </div>
        </div>

        {/* Breakdown */}
        <p
          className="text-uppercase fw-semibold mb-3"
          style={{ fontSize: "11px", color: "black", letterSpacing: "0.15em" }}
        >
          Answer Breakdown
        </p>

        {responseData.results.map((result, i) => (
          <QuestionCard
            key={result.questionId}
            result={result}
            index={i}
            allOptions={
              optionsMap[result.questionId] ||
              [result.selectedAnswer, result.correctAnswer].filter(Boolean)
            }
          />
        ))}

        {/* Retake + Completion block */}
        <div className="text-center">
          <button type="button" className="btn btn-dark" onClick={onRestart}>
            ↺ &nbsp; Retake Quiz
          </button>
        </div>

        {/* ── Last-quiz: PDF button or failure message ── */}
        {/* {sakyo && allCompleted && (
          <div className="mt-4 text-center">
            {allAbove50 ? (
              <button
                type="button"
                className="btn btn-primary px-4 py-2 fw-semibold rounded-3 shadow-sm d-inline-flex align-items-center gap-2"
                onClick={() => {
                  // PDF generation will be integrated here
                  console.log("Generate PDF clicked");
                }}
              >
                📄 Generate PDF
              </button>
            ) : (
              <div
                className="alert alert-warning fw-semibold"
                role="alert"
              >
                You attempted all the questions but you have not scored above
                50% in every quiz.
              </div>
            )}
          </div>
        )} */}
      </div>

      {/* ── Completion Modal (only when sakyo = all quizzes done) ── */}
      <Modal
        isOpen={isModalOpen}
        backdrop="static"
        keyboard={false}
        centered
      >
        <ModalHeader>Result</ModalHeader>
        <ModalBody>
          {/* ── Loading spinner while certificate API is in-flight ── */}
          {isCertLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "120px" }}
            >
              <div className="spinner-border" role="status" style={{ color: "rgb(123,31,162)" }}>
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="p-2">
              {/* ── Case 2: overall all-quiz score < 60 (allAbove50 false) ── */}
              {!allAbove50 && (
                <>
                  <p className="mb-4">
                    You attempted all the questions but you have not scored above
                    60% in every quiz.
                  </p>
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn px-4"
                      style={{
                        backgroundColor: "#9c2aa5", // lighter version
                        borderColor: "#9c2aa5",
                        color: "#fff",
                        transition: "0.3s"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#86158E";
                        e.target.style.borderColor = "#86158E";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#9c2aa5";
                        e.target.style.borderColor = "#9c2aa5";
                      }}
                      onClick={() => {
                        resetScore();
                        toggleModal();
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </>
              )}

              {/* ── Case 1: all-quiz score ≥ 60 ── */}
              {allAbove50 && (
                <>
                  <h5 className="fw-bold mb-3">Congratulations! 🎉</h5>

                  {/* Sub-case A: first time certificate email was sent */}
                  {firstMail && (
                    <>
                      <p className="mb-4">
                        You have scored above 60% in all quizzes. You are eligible
                        to generate your certificate PDF.
                      </p>
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          type="button"
                          className="btn btn-primary px-4 py-2 fw-semibold rounded-3 shadow-sm d-inline-flex align-items-center gap-2"
                          onClick={() => {
                            resetScore();
                            window.open(
                              `/certificate?name=${encodeURIComponent(userName)}&course=${encodeURIComponent(courseName)}&date=${encodeURIComponent(date)}`,
                              "_blank",
                            );
                            toggleModal();
                          }}
                        >
                          Generate PDF
                        </button>
                      </div>
                    </>
                  )}

                  {/* Sub-case B: certificate already sent before (success: false) */}
                  {!firstMail && (
                    <>
                      <p className="mb-1 text-muted" style={{ fontSize: "0.9rem" }}>
                        You are already certified.
                      </p>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn px-4"
                          style={{
                            backgroundColor: "#9c2aa5", // lighter version
                            borderColor: "#9c2aa5",
                            color: "#fff",
                            transition: "0.3s"
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#86158E";
                            e.target.style.borderColor = "#86158E";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#9c2aa5";
                            e.target.style.borderColor = "#9c2aa5";
                          }}
                          onClick={() => {
                            resetScore();
                            toggleModal();
                          }}
                        >
                          Confirm
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
}
